import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ComponentLoaderDirective } from './../../../component-loader.directive';
import { DgDialogAction, DgDialogData } from './dg-dialog.model';

@Component({
  selector: 'dg-dialog',
  templateUrl: './dg-dialog.component.html',
  styleUrls: ['./dg-dialog.component.scss'],
})
export class DgDialogComponent implements OnInit {
  @ViewChild(ComponentLoaderDirective)
  customComponentRef: ComponentLoaderDirective;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DgDialogData,
    private dialogRef: MatDialogRef<DgDialogComponent>
  ) {}

  ngOnInit(): void {}

  getActionDisabled(action: DgDialogAction) {
    if (this.data?.component && action?.disabled instanceof Function) {
      return (action?.disabled as any)?.(
        this.customComponentRef?.componentRef?.instance
      );
    }
    return action?.disabled;
  }

  getActionValue(action: DgDialogAction) {
    if (this.data?.component && action?.value instanceof Function) {
      return (action?.value as any)?.(
        this.customComponentRef?.componentRef?.instance
      );
    }
    return action?.value;
  }

  onAction(action: DgDialogAction) {
    if (action?.waitForValue) {
      (this.getActionValue(action) as Observable<any>).subscribe((data) =>
        this.dialogRef.close(data)
      );
    } else {
      this.dialogRef.close(this.getActionValue(action));
    }
  }
}
